import { handleActions } from 'redux-actions';

import { resourceUpserters } from '../core';
import type { QcsSyncResourceStoreProps } from '../core/resourceStoreTypes';
import * as actions from './customersActions';
import { type CustomerProps, type CustomersStore, mkCustomersStore } from './customersTypes';

const reducer = handleActions<
  CustomersStore,
  | ReturnType<typeof actions.getCustomers>
  | ReturnType<typeof actions.getCustomersSuccess>
  | ReturnType<typeof actions.getCustomersFailure>
  | ReturnType<typeof actions.createCustomer>
  | ReturnType<typeof actions.createCustomerSuccess>
  | ReturnType<typeof actions.updateCustomer>
  | ReturnType<typeof actions.updateCustomerSuccess>
  | ReturnType<typeof actions.deleteCustomer>
  | ReturnType<typeof actions.deleteCustomerSuccess>
>(
  {
    [actions.getCustomers.type]: (state) => state.merge({ isLoading: true, error: undefined }),
    [actions.getCustomersSuccess.type]: (state, { payload }) =>
      resourceUpserters.upsertResources<CustomerProps, QcsSyncResourceStoreProps<CustomerProps>>(state, payload),
    [actions.getCustomersFailure.type]: (state, { payload: error }) =>
      resourceUpserters.completeWithError<CustomerProps, QcsSyncResourceStoreProps<CustomerProps>>(state, error),

    [actions.createCustomer.type]: (state, { payload }) =>
      resourceUpserters.upsertResource<CustomerProps, QcsSyncResourceStoreProps<CustomerProps>>(state, payload),
    [actions.createCustomerSuccess.type]: (state, { payload }) =>
      resourceUpserters.upsertResource<CustomerProps, QcsSyncResourceStoreProps<CustomerProps>>(state, payload),

    [actions.updateCustomer.type]: (state, { payload }) =>
      resourceUpserters.upsertResource<CustomerProps, QcsSyncResourceStoreProps<CustomerProps>>(state, payload),
    [actions.updateCustomerSuccess.type]: (state, { payload }) =>
      resourceUpserters.upsertResource<CustomerProps, QcsSyncResourceStoreProps<CustomerProps>>(state, payload),

    [actions.deleteCustomer.type]: (state, { payload }) =>
      resourceUpserters.upsertResource<CustomerProps, QcsSyncResourceStoreProps<CustomerProps>>(state, payload),
    [actions.deleteCustomerSuccess.type]: (state, { payload }) =>
      resourceUpserters.upsertResource<CustomerProps, QcsSyncResourceStoreProps<CustomerProps>>(state, payload),
  },
  mkCustomersStore(),
);

export default reducer;
